import gql from 'graphql-tag';

export const collaboratingUserCursorMovedOnSurfaceSubscription = gql`
  subscription collaboratingUserCursorMovedOnSurface(
    $surface: ID!
    $user: ID!
  ) {
    collaboratingUserCursorMovedOnSurfaceSubscription(
      surface: $surface
      user: $user
    ) {
      id
      user {
        id
        email
        fullName
      }
      cursorPosition {
        x
        y
      }
      color
      surface
    }
  }
`;
